import React, {useEffect, useState} from 'react';
import {Provinces} from "@app/constants/Provinces";
import ReactChipInput from "react-chip-input";
import {arrayIncludeItem, arrayToString, optionsToString, stringToArray, stringToOption} from "@app/utils/CommonUtils";
import {cloneDeep} from "lodash";
import {requestSaveEmployer} from "@app/services/EmployerService";
import {ResponseCode} from "@app/constants/Common";
import {toast} from "react-toastify";
import {alertMessage, Messages} from "@app/constants/Messages";
import Select from "react-select";
import {CandidateListMode} from "@pages/candidate/list/CandidateListTable";
import {
    BDStatusOption, BeContactPoint,
    BeContactPointOption,
    RoleAtEmployer,
    RoleAtEmployerOption
} from "@pages/employer/constant/Constant";
import {Link} from "react-router-dom";

const EmployeeTableList = (props) => {
    const [employees, setEmployees] = useState([]);

    const {employeeList, onSave} = props

    const changeSomeStringValueToOption = (inputEmp={}) => {
        const emp = cloneDeep(inputEmp)
        emp.bd_status = stringToOption(inputEmp.bd_status, false)
        emp.role_at_employer = stringToOption(inputEmp.role_at_employer)
        emp.be_contact_point = BeContactPointOption.filter(op => op.value === emp.be_contact_point)
        return emp
    }

    useEffect(() => {
        if (employeeList) {
            const empList = employeeList.map(item => {
                return changeSomeStringValueToOption(item)
            })
            setEmployees(empList)
        } else {
            setEmployees([])
        }
    }, [employeeList]);

    const onChangeEmployeeInfo = (index, fieldName, value) => {
        employees[index][fieldName] = value
        setEmployees([...employees])
    };

    const onSaveClicked = (index) => {
        employees[index].isEdit = false;
        setEmployees([...employees])
        if (onSave) {
            const temp = cloneDeep(employees[index]);

            temp.bd_status = optionsToString(temp.bd_status, false)
            temp.role_at_employer = optionsToString(temp.role_at_employer)
            temp.be_contact_point = optionsToString(temp.be_contact_point, false)
            onSave(temp)
        }
    };

    const onEditClicked = (index) => {
        employees[index].isEdit = true;
        setEmployees([...employees])
    };

    const concatMonthYear = (month, year) => {
      if (!month && !year) {
          return ""
      }

      if (month && year) {
          return month + "/" + year
      }

      return month || year
    }

    return (
        <table
            className='table table-hover table-bordered text-nowrap'
            style={{
                maxHeight: '80vh',
                overflow: 'scroll',
                minHeight: 300
            }}
        >
            <thead>
            <tr>
                <th>STT</th>
                <th>Person ID</th>
                <th>Họ và tên</th>
                <th>Time bắt đầu</th>
                <th>Time kết thúc</th>
                <th>Time có làm</th>
                <th>Displayed company</th>
                <th>Displayed title </th>
                <th>Working status</th>
                <th>Note as a Contact Point/Hiring Mgr</th>
                <th>Vai trò tại Employer</th>
                <th>Be contact point?</th>
                {employees.length > 0 && employees[0].is_current &&
                    <th>BD status (Person)&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;</th>
                }
                <th>Hành động</th>
            </tr>
            </thead>
            <tbody>
            {employees.map((item, index) => (
                <tr key={`career_summary_${index}`}>
                    <td>{index + 1}</td>
                    <td>
                        <Link to={`/candidate/detail/${item.candidate_id}`}
                              target='_blank'
                              rel='noopener noreferrer'>{item.candidate_id}</Link>
                    </td>
                    <td>
                        <Link to={`/candidate/detail/${item.candidate_id}`}
                              target='_blank'
                              rel='noopener noreferrer'>{item.full_name}</Link>
                    </td>
                    <td>{concatMonthYear(item.work_start_month, item.work_start_year)}</td>
                    <td>{concatMonthYear(item.work_month, item.work_year)}</td>
                    <td>{concatMonthYear(item.work_end_month, item.work_end_year)}</td>
                    <td>{item.displayed_company}</td>
                    <td>{item.displayed_title}</td>
                    <td>{item.work_status}</td>
                    <td>{item.contact_point_note}</td>
                    <td>
                        <Select
                            options={RoleAtEmployerOption}
                            isDisabled={!item.isEdit}
                            isMulti
                            value={item.role_at_employer}
                            onChange={value => {
                                onChangeEmployeeInfo(index, "role_at_employer", value);
                            }}
                        />
                        {/*<input type='text' className='form-control'*/}
                        {/*       value={item["role_at_employer"] || ''}*/}
                        {/*       name={"role_at_employer"}*/}
                        {/*       disabled={!item.isEdit}*/}
                        {/*       onChange={event => onChangeEmployeeInfo(index,"role_at_employer", event.target.value)}/>*/}
                    </td>
                    <td>
                        <Select
                            options={BeContactPointOption}
                            isDisabled={!item.isEdit}
                            value={item.be_contact_point}
                            onChange={value => {
                                onChangeEmployeeInfo(index, "be_contact_point", value);
                            }}
                        />
                        {/*<input type='text' className='form-control'*/}
                        {/*       value={item["be_contact_point"] || ''}*/}
                        {/*       name={"be_contact_point"}*/}
                        {/*       disabled={!item.isEdit}*/}
                        {/*       onChange={event => onChangeEmployeeInfo(index,"be_contact_point", event.target.value)}/>*/}

                    </td>
                    <td>
                        {item.is_current &&
                            // <td>{item.bd_status}</td>
                            <Select
                                options={BDStatusOption}
                                isDisabled
                                value={item.bd_status}
                                onChange={value => {
                                    onChangeEmployeeInfo(index, "bd_status", value);
                                }}
                            />
                        }
                    </td>
                    <td>
                        {item.isEdit &&
                        <button type={"button"}
                                onClick={() => onSaveClicked(index)}
                                className={'btn btn-info'}>Save
                        </button>
                        }

                        {!item.isEdit &&
                        <div className="btn-group">
                            <button type="button" className="btn btn-default">Action</button>
                            <button type="button" className="btn btn-default dropdown-toggle dropdown-icon"
                                    data-toggle="dropdown">
                                <span className="sr-only">Toggle Dropdown</span>
                            </button>

                            <div className="dropdown-menu" role="menu">
                                <button type={"button"}
                                        onClick={() => onEditClicked(index)}
                                        rel="noopener noreferrer" className={'dropdown-item'}>Edit
                                </button>
                            </div>
                        </div>
                        }
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    )
}

export default EmployeeTableList;
